import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Crown, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

const UpgradePrompt = ({ 
  feature = 'this feature',
  requiredPlan = 'Growth',
  description = 'Upgrade your plan to access this feature and unlock more capabilities.',
  icon: Icon = Lock
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center min-h-[60vh] p-8"
    >
      <div className="max-w-md text-center">
        {/* Icon */}
        <div className="mb-6 inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-amber-100 to-amber-50 border-2 border-amber-200">
          <Icon className="w-10 h-10 text-amber-500" />
        </div>
        
        {/* Content */}
        <h2 className="text-2xl font-bold text-slate-900 mb-3">
          Unlock {feature}
        </h2>
        <p className="text-slate-600 mb-6">
          {description}
        </p>
        
        {/* Required Plan Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-full text-sm text-slate-600 mb-6">
          <Crown className="w-4 h-4 text-amber-500" />
          <span>Requires <strong className="text-slate-900">{requiredPlan}</strong> plan or higher</span>
        </div>
        
        {/* CTA Button */}
        <div>
          <Link
            to="/partners/subscription"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg shadow-blue-500/25"
          >
            <Crown className="w-5 h-5" />
            Upgrade Now
            <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        
        {/* Features Teaser */}
        <div className="mt-8 p-4 bg-slate-50 rounded-xl border border-slate-200">
          <p className="text-sm font-medium text-slate-700 mb-2">With {requiredPlan} plan, you get:</p>
          <ul className="text-sm text-slate-600 space-y-1">
            {requiredPlan === 'Growth' && (
              <>
                <li>• Inventory management with up to 25 SKUs</li>
                <li>• Custom watermark on generated images</li>
                <li>• Priority processing queue</li>
                <li>• Up to 3 team members</li>
              </>
            )}
            {requiredPlan === 'Professional' && (
              <>
                <li>• Advanced analytics dashboard</li>
                <li>• Analytics data export</li>
                <li>• Up to 100 SKUs in inventory</li>
                <li>• Up to 5 team members</li>
              </>
            )}
          </ul>
        </div>
      </div>
    </motion.div>
  );
};

export default UpgradePrompt;
